import { Box } from '@rebass/emotion';
import styles from './TermsBox.styles';

export interface TermsItem {
  title: string;
  body: string;
}

const TermsBox = ({ title, body }: TermsItem): JSX.Element => {
  return (
    <Box css={styles.wrapper} p={3} pb={4}>
      <h4 data-testid="termsbox-title" css={styles.title}>
        {title}
      </h4>

      <div
        data-testid="termsbox-body"
        css={styles.body}
        /* eslint-disable react/no-danger */
        dangerouslySetInnerHTML={{ __html: body }}
        /* eslint-enable react/no-danger */
      />
    </Box>
  );
};

export default TermsBox;
